import styled from 'styled-components'
import { Typography } from '~components'
import { StreamlineSelfie as DefaultStreamlineSelfie } from '~components'

export const Message = styled.div`
  text-align: center;
  width: 370px;
  top: 160px;
  position: absolute;
  @media (max-width: ${({ theme }) => theme.breakpoint.sm.maxWidth}) {
    width: auto;
  }
`

export const StreamlineSelfie = styled(DefaultStreamlineSelfie)`
  margin-bottom: ${({ theme }) => theme.spacing.km6};
`

export const Title = styled(Typography).attrs({ as: 'h2' })`
  letter-spacing: -0.03em;
  margin-bottom: ${({ theme }) => theme.spacing.km2};
`

export const Text = styled(Typography).attrs({ as: 'p' })`
  font-size: ${({ theme }) => theme.font.size.m3};
  color: ${({ theme }) => theme.neutral.text.default};
  letter-spacing: -0.03em;
`
